import React from "react";

interface LoaderProps {
	/**
	 * Size of the loader
	 * @default "md"
	 */
	size?: "sm" | "md" | "lg" | "xl";
	/**
	 * Show loading text below the logo
	 * @default false
	 */
	showText?: boolean;
	/**
	 * Custom loading text
	 * @default "Loading..."
	 */
	text?: string;
	/**
	 * Full screen loader (centers in viewport)
	 * @default false
	 */
	fullScreen?: boolean;
	/**
	 * Additional className for the container
	 */
	className?: string;
}

const sizeMap = {
	sm: "h-8 w-8",
	md: "h-12 w-12",
	lg: "h-16 w-16",
	xl: "h-24 w-24",
};

const Loader: React.FC<LoaderProps> = ({
	size = "md",
	showText = false,
	text = "Loading...",
	fullScreen = false,
	className = "",
}) => {
	const containerClasses = fullScreen
		? "min-h-screen flex items-center justify-center bg-background"
		: "flex items-center justify-center";
	const contentClasses = showText ? "text-center" : "";

	return (
		<div className={`${containerClasses} ${className}`}>
			<div className={contentClasses}>
				<img
					src="/assets/images/mobile_logo.png"
					alt="Loading"
					className={`${
						sizeMap[size]
					} w-auto object-contain animate-pulse mx-auto ${
						showText ? "mb-4" : ""
					}`}
				/>
				{showText && <p className="text-muted-foreground text-sm">{text}</p>}
			</div>
		</div>
	);
};

export default Loader;
